import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const apiSlice = createApi({
    reducerPath: 'backApi',
    baseQuery: fetchBaseQuery({ baseUrl: '/api/' }),
    endpoints: (builder) => ({
        unitList: builder.query({
            query: (name) => `/unit-list`,
        }),
        prosmTypeList: builder.query({
            query: () => ({
                url: `/prosm-type-list`,
                method: 'GET'
            })
        }),
        permissionList: builder.query({
            query: () => ({
                url: `/permission-list`,
                method: 'GET'
            })
        })
    }),
})

export const {
    useUnitListQuery,
    useProsmTypeListQuery,
    usePermissionListQuery
} = apiSlice;
